
import React from 'react';

export const MusicHeartIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35zM7.5 5C5.52 5 4 6.52 4 8.5c0 2.73 2.5 5.2 7 8.91l1 1.09 1-1.09c4.5-3.71 7-6.18 7-8.91C20 6.52 18.48 5 16.5 5c-1.43 0-2.78.68-3.65 1.76h-1.7C10.28 5.68 8.93 5 7.5 5z"/>
    <path d="M13.5 11.5c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2V9h3V7h-4v4.5z" />
  </svg>
);
